const UUID_REGEX = /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const MAX_EDM_FILENAME_LENGTH = 150;

const sanitizeDocumentId = (documentId) => {
    if (!documentId) {
        return '';
    }
    return String(documentId).trim();
};

const splitFileName = (name = '') => {
    const trimmed = name.trim();
    if (!trimmed) {
        return { baseName: '', extension: '' };
    }
    const lastDot = trimmed.lastIndexOf('.');
    if (lastDot <= 0) {
        return { baseName: trimmed, extension: '' };
    }
    return {
        baseName: trimmed.slice(0, lastDot),
        extension: trimmed.slice(lastDot)
    };
};

const formatFileNameWithDocumentId = (name, documentId, maxLength = MAX_EDM_FILENAME_LENGTH) => {
    const sanitizedId = sanitizeDocumentId(documentId);
    if (!name || !sanitizedId) {
        return name;
    }

    const { baseName, extension } = splitFileName(name);
    const suffix = `_${sanitizedId}`;

    // Ensure the final string never exceeds the configured max length
    // Prefer trimming the base name while keeping suffix + extension intact
    let safeExtension = extension || '';
    let maxBaseLength = maxLength - suffix.length - safeExtension.length;

    if (maxBaseLength < 0) {
        const overflow = Math.abs(maxBaseLength);
        safeExtension = safeExtension.slice(0, Math.max(0, safeExtension.length - overflow));
        maxBaseLength = 0;
    }

    let truncatedBase = baseName.slice(0, Math.max(0, maxBaseLength));
    if (!truncatedBase && maxBaseLength === 0 && !safeExtension) {
        // As a fallback, allow suffix alone if name was empty and no extension exists
        truncatedBase = '';
    }

    const formatted = `${truncatedBase}${suffix}${safeExtension}`;
    if (formatted.length <= maxLength) {
        return formatted;
    }
    // Absolute fallback: hard trim the entire string to the max length
    return formatted.slice(0, maxLength);
};

const stripDocumentIdFromName = (name, documentId) => {
    if (!name) {
        return name;
    }
    const sanitizedId = sanitizeDocumentId(documentId);
    const { baseName, extension } = splitFileName(name);

    if (!baseName) {
        return name;
    }

    const suffix = sanitizedId ? `_${sanitizedId}` : null;
    if (suffix && baseName.endsWith(suffix)) {
        return `${baseName.slice(0, -suffix.length)}${extension}` || name;
    }

    if (!sanitizedId && UUID_REGEX.test(baseName)) {
        return `${baseName.replace(UUID_REGEX, '')}${extension}` || name;
    }

    return name;
};

module.exports = {
    MAX_EDM_FILENAME_LENGTH,
    formatFileNameWithDocumentId,
    stripDocumentIdFromName
};